// src/components/navigation/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import Logo from '../common/Logo';

const FooterSection = ({ title, children }) => (
  <div className="space-y-4">
    <h3 className="text-lg font-semibold text-white">{title}</h3>
    {children}
  </div>
);

const Footer = () => {
  return (
    <footer className="relative z-10 bg-[rgba(0,0,0,0.6)] backdrop-blur-sm">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo i opis */}
          <div className="space-y-4">
            <Logo className="text-white" />
            <p className="text-gray-300 text-sm">
              Auto Kosmetyka | Auto Detailing Pranie Tapicerki
            </p>
          </div>

          {/* Szybkie linki */}
          <FooterSection title="Szybkie linki">
            <nav className="space-y-2">
              {[
                { name: 'Strona główna', path: '/' },
                { name: 'Cennik', path: '/services' },
                { name: 'Galeria', path: '/gallery' },
                { name: 'Lokalizacja', path: '/location' },
                { name: 'Kontakt', path: '/contact' }
              ].map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  className="block text-gray-300 hover:text-white transition-colors"
                >
                  {link.name}
                </Link>
              ))}
            </nav>
          </FooterSection>

          {/* Godziny otwarcia */}
          <FooterSection title="Godziny otwarcia">
            <div className="space-y-2 text-gray-300">
              <p>Poniedziałek - Piątek: 9:00 - 18:00</p>
              <p>Sobota: 9:00 - 16:00</p>
              <p>Niedziela: nieczynne</p>
            </div>
          </FooterSection>

          {/* Kontakt */}
          <FooterSection title="Kontakt">
            <div className="space-y-2 text-gray-300">
              <a href="https://maps.app.goo.gl/MvMgHRTFvWa45bV89" target="_blank" rel="noopener noreferrer" className="block hover:text-white transition-colors">
                <p>Ignacego Matuszewskiego 11A</p>
                <p>80-288 Gdańsk</p>
              </a>
              <p>Tel: <a href="tel:+48508198200" className="hover:text-white transition-colors">+48 508 198 200</a></p>
              <p>Email: <a href="mailto:mdclean@interia.pl" className="hover:text-white transition-colors">mdclean@interia.pl</a></p>
              <p>
                <a 
                  href="https://www.facebook.com/profile.php?id=61564606325791" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="hover:text-white transition-colors inline-flex items-center gap-2"
                >
                  <svg 
                    className="w-5 h-5" 
                    fill="currentColor" 
                    viewBox="0 0 24 24" 
                    aria-hidden="true"
                  >
                    <path 
                      fillRule="evenodd" 
                      d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" 
                      clipRule="evenodd" 
                    />
                  </svg>
                  Facebook
                </a>
              </p>
            </div>
          </FooterSection>
        </div>

        {/* Copyrights */}
        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="text-center text-gray-400">
            © {new Date().getFullYear()} MD Clean. Wszelkie prawa zastrzeżone.
          </p>
          <p className="text-center text-gray-400 mt-2">
            Stworzone przez{' '}
            <a
              href="https://brightweb.pl"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-400 hover:text-primary-300 transition-colors"
            >
              BrightWeb.pl
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
